import React, { createContext, useState, useContext, useCallback } from "react";
import { fetchAdminProfile } from "../utils/fetchAdminProfile";
import { getRoleName } from "../utils/permissions";

const DataContext = createContext();

export const useDataContext = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [role, setRole] = useState("");
  const [adminProfile, setAdminProfile] = useState(null);
  const [profileLoaded, setProfileLoaded] = useState(false);

  const updateModules = (newData) => {
    setModules(newData);
  };

  const clearAdminProfile = useCallback(() => {
    setAdminProfile(null);
    setRole("");
    setProfileLoaded(false);
  }, []);

  const refreshAdminProfile = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setProfileLoaded(false);
    try {
      const result = await fetchAdminProfile();
      if (result.ok) {
        setAdminProfile(result.data);
        setRole(getRoleName(result.data));
        return { ok: true, data: result.data };
      }
      return {
        ok: false,
        unauthorized: result.unauthorized,
        message: result.message,
      };
    } catch (e) {
      console.error(e);
      return { ok: false };
    } finally {
      setProfileLoaded(true);
    }
  }, []);

  return (
    <DataContext.Provider
      value={{
        modules,
        updateModules,
        role,
        setRole,
        adminProfile,
        setAdminProfile,
        profileLoaded,
        setProfileLoaded,
        clearAdminProfile,
        refreshAdminProfile,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
